import { useChannel } from "../../react";
import { graderAblyChannelName } from "../messaging";

export function useGraderChannel(id: string, onMessage?: (message: unknown) => void | Promise<void>) {
	const channelName = graderAblyChannelName(id);
	const { channel } = useChannel(channelName, onMessage as (message: unknown) => void);

	return { channel };
}
